<template>
  <section class="social-network">
    <div class="container">
      <div class="social-network__body">
        <div class="social-network__title">
          {{ data.title }}
        </div>
        <div class="social-network__socials">
          <BaseButton
            :url="`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`"
            target="_blank"
            tag="a"
            theme="white"
          >
            Розповісти в Facebook
          </BaseButton>
          <div class="social-network__socials-links">
            <a href="https://www.facebook.com/MastercardUkraine/" target="_blank" class="social-network__socials-link">
              <Facebook />
            </a>
            <a href="https://www.instagram.com/mastercardukraine/" target="_blank" class="social-network__socials-link">
              <Instagram />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import Facebook from '@/assets/svg/facebook.svg'
  import Instagram from '@/assets/svg/instagram.svg'
  export default {
    name: 'SocialNetworkBlock',

    components: {
      Facebook,
      Instagram
    },
    
    props: {
      data: {
        type: Object,
        default: () => ({})
      }
    },

    data () {
      return {
        pageUrl: null
      }
    },
    created () {
      this.pageUrl = document.location.href
      // console.log(document.location.href)
    }
  }
</script>

<style lang="scss">
.social-network {
  padding: 192px 0;
  position: relative;

  @include tablet {
    padding: 96px 0;
  }

  &__title {
    width: 100%;
    max-width: 365px;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.18;
    color: $c-medium-black;
    text-transform: uppercase;

    @include tablet {
      max-width: 100%;
      margin-bottom: 40px;
    }

    @include mobile {
      font-size: 20px;
      line-height: 30px;
      text-align: center;
    }
  }

  &__body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 864px;
    margin: 0 auto;
    overflow: hidden;

    @include tablet {
      flex-wrap: wrap;
    }
  }

  &__socials {
    display: flex;

    @include mobile {
      flex-wrap: wrap;
      justify-content: center;
      width: 100%;
    }

    &-links {
      margin-left: 56px;

      @include mobile {
        width: 100%;
        text-align: center;
        margin-top: 24px;
        margin-left: 0;
      }
    }

    &-link {
      display: inline-block;
      
      svg {
        width: 48px;
        height: 48px;

        @include mobile {
          width: 36px;
          height: 36px;
        }
      }

      svg > *{
        transition: 0.5s;
      }

      &:not(:last-child) {
        margin-right: 24px;
      }

      @include hover {
        svg > *{
          fill: $c-red;
        }
      }
    }
  }
}
</style>
